import { Link } from 'react-router-dom';
import { BandeauSignature } from '../../components/index.js';
import { useOrganisateur } from '../../hooks/useOrganisateur.js';
import { EvenementForm } from './EvenementForm.js';

/** Écran 1 : création de l'événement (non dessiné dans la passation). */
export function NouvelEvenement() {
  useOrganisateur();
  return (
    <div className="page-liste">
      <header className="entete-liste">
        <Link to="/app" className="logo" style={{ textDecoration: 'none', color: 'inherit' }}>
          <BandeauSignature petit />
          <span className="display" style={{ fontSize: 22 }}>
            Dîner tournant
          </span>
        </Link>
      </header>
      <main className="contenu-liste" style={{ maxWidth: 760 }}>
        <div className="entete-page">
          <div>
            <h1 className="display">Nouvel événement</h1>
            <p className="texte-doux">Un repas en trois étapes, chaque étape chez un hôte différent.</p>
          </div>
        </div>
        <EvenementForm />
      </main>
    </div>
  );
}
